import { Box, Typography, getColor, Button, Icons } from "fds";
import { useTranslation } from "react-i18next";

/** 필터를 적용했을때, 검색결과가 없을때 나오는 화면 */
const EmptyFilterPage = ({
  handleInitFilter,
  pageType,
}: {
  handleInitFilter?: () => void;
  pageType?: string;
}) => {
  const { t } = useTranslation();
  return (
    <Box
      alignItems="center"
      direction="column"
      height={pageType?.includes("client") ? 384 : undefined}
      justifyContent={pageType?.includes("client") ? "center" : undefined}
    >
      <img
        src={require("../../shared/images/pages/File/emptySearch.png")}
        style={{
          marginTop: pageType && pageType?.includes("client") ? 0 : 160,
        }}
        alt="noFilter"
        width={200}
      />
      <Typography type="h3" classes=" mg mt-20">
        {t("common.noFilterTitle")}
      </Typography>
      <Typography
        type="body2_rg"
        classes="mg mt-8"
        whiteSpace="pre"
        textAlign="center"
        exactColor={getColor("COLOR_TEXT_SECONDARY")}
      >
        {pageType === "compressed_log" ? t("search.noFile") + "\n" : ""}
        {handleInitFilter
          ? t("common.noFilterDesc")
          : t("common.noFilterWithoutInit")}
      </Typography>
      {handleInitFilter && (
        <Button
          label={t("common.initFilter")}
          btnStyle="fill"
          classes="mg mt-20"
          size={"lg"}
          onClick={handleInitFilter}
          leadingIcon={<Icons variant="line" label="redoLeft" />}
        />
      )}
    </Box>
  );
};

export default EmptyFilterPage;
